import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Optimized selector hook for PacksTab component
 * Uses shallow comparison to prevent unnecessary re-renders
 *
 * @returns Selected pack inventory state and actions
 */
export const usePackInventoryState = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      inventoryPacks: state.inventoryPacks,
      inventory: state.inventory,
      dependencies: state.dependencies,
      rawInventory: state.rawInventory,
      modifiedInventory: state.modifiedInventory,
      timePeriodStore: state.timePeriodStore,
    }))
  );
};
